import { asModal } from 'src/components/hoc/asModal'
import { FacebookLinking } from 'src/components/Modal/FacebookModal'
import { Article } from 'src/models/Article'
import { previousPath, SIGN_IN } from 'src/utils/routes'
import { InstallApp } from './InstallApp'
import { LatestArticle } from './LatestArticle'
import { UpdateNeeds } from './UpdateNeeds'

const POP_UP_TYPES = [
  'should_update_needs',
  'latest_article',
  'app',
  'facebook_linking',
] as const

export type PopUpType = typeof POP_UP_TYPES[number]

export const popUpAvailable = (arg: any): arg is PopUpType =>
  POP_UP_TYPES.includes(arg)

type PopUpProps = {
  popUp: PopUpType
  latestArticle?: Article
}

export const PopUpModal = asModal<PopUpProps>(
  ({ popUp, latestArticle, close }) => {
    if (popUp === 'should_update_needs') return <UpdateNeeds />
    if (popUp === 'latest_article' && latestArticle)
      return <LatestArticle article={latestArticle} />
    if (popUp === 'app') return <InstallApp />
    if (popUp === 'facebook_linking' && previousPath() === SIGN_IN)
      return <FacebookLinking onPopup />
    close(undefined, { immediately: true })
    return <></>
  },
)
